var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HeadBar',{attrs:{"title":"报名查询"}}),_c('ApplySearch',{attrs:{"defaultName":_vm.defaultName,"defaultNumber":_vm.defaultNumber}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }